$(document).ready(function () {
    var scrollpos = sessionStorage.getItem('scrollpos');
    let fieldId = null
    let filemanagerQuestionnaire = document.querySelector('#filemanager-questionnaire')
    let folder = filemanagerQuestionnaire.dataset.folder
    let dossier = filemanagerQuestionnaire.dataset.dossier

    if (scrollpos) {
        document.getElementById("content").scrollTo(0, scrollpos);
        sessionStorage.removeItem('scrollpos');
    }

    /* Handling note inputs */
    noteInputs = document.getElementsByClassName("noteInput");
    for (var i = 0; i < noteInputs.length; i++) {
        noteInputs[i].addEventListener('change', saveNote, false)
    }

    function saveNote() {
        fieldId = this.closest('tr').dataset.fieldId
        let field = this.closest('tr');

        if (folder > 0) {
            var url = '/files/' + dossier + '/store-note/' + fieldId + '/' + folder
        } else {
            var url = '/files/' + dossier + '/store-note' + fieldId
        }

        $.post(url, {
            note: this.value,
        }).done(function (data) {
            if (data['highlight']) {
                field.style.backgroundColor = "rgb(205,239,255)";
            } else {
                field.style.backgroundColor = "";
            }
        });
    }

    /* Handleing ignore checkbox */
    ignoreChecks = $('input[name="ignore_check"]');
    for (var i = 0; i < ignoreChecks.length; i++) {
        ignoreChecks[i].addEventListener('change', saveIgnore, false)
    }

    function saveIgnore() {
        fieldId = this.closest('tr').dataset.fieldId
        let field = this.closest('tr');

        if (folder > 0) {
            var url = '/files/' + dossier + '/store-ignore/' + fieldId + '/' + folder
        } else {
            var url = '/files/' + dossier + '/store-ignore' + fieldId
        }

        $.post(url, {
            ignore: $(this).is(':checked') == true ? 1 : 0,
        }).done(function (data) {
            if (data['highlight']) {
                field.style.backgroundColor = "rgb(205,239,255)";
            } else {
                field.style.backgroundColor = "";
            }
        });
    }

    /* Handling value inputs */
    valueInputs = document.getElementsByClassName("valueInput");
    for (var i = 0; i < valueInputs.length; i++) {
        valueInputs[i].addEventListener('change', saveValue, false)
    }

    function saveValue() {
        fieldId = this.closest('tr').dataset.fieldId;

        let field = this.closest('tr');
        if (this.value.length > 0) {
            field.style.backgroundColor = "rgb(205,239,255)";
        } else {
            field.style.backgroundColor = "";
        }

        if (folder > 0) {
            var url = '/files/' + dossier + '/store-value/' + fieldId + '/' + folder
        } else {
            var url = '/files/' + dossier + '/store-value' + fieldId
        }

        $.post(url, {
            value: this.value,
        }).done(function (data) {

        });
    }

    /* Handling date inputs */
    dateInputs = document.getElementsByClassName("dateInput");
    for (var i = 0; i < dateInputs.length; i++) {
        dateInputs[i].addEventListener('change', saveDate, false)
    }

    function saveDate() {
        fieldId = this.closest('tr').dataset.fieldId;

        let field = this.closest('tr');
        if (this.value.length > 0) {
            field.style.backgroundColor = "rgb(205,239,255)";
        } else {
            field.style.backgroundColor = "";
        }

        if (folder > 0) {
            var url = '/files/' + dossier + '/store-date/' + fieldId + '/' + folder
        } else {
            var url = '/files/' + dossier + '/store-date' + fieldId
        }

        $.post(url, {
            date: this.value,
        }).done(function (data) {
            if (data['highlight']) {
                field.style.backgroundColor = "rgb(205,239,255)";
            } else {
                field.style.backgroundColor = "";
            }
        });
    }
});
